import * as yup from 'yup';

import { toBoolean, toDate, toFloat, toInt, toString } from 'helpers/primitiveParsing';

export const yupString = yup.string().transform((_, originalValue) => toString(originalValue));
export const yupBool = yup.boolean().transform((_, originalValue) => toBoolean(originalValue));
export const yupInt = yup.number().transform((_, originalValue) => toInt(originalValue));
export const yupFloat = yup.number().transform((_, originalValue) => toFloat(originalValue));
export const yupDate = yup.date().transform((_, originalValue) => toDate(originalValue));
export const yupArray = (schema: yup.BaseSchema) =>
  yup
    .array(schema)
    .transform((transformedValue, _) => (transformedValue === null ? [] : transformedValue))
    .default([]);
export const yupEnum = <T>(values: T[]) =>
  yupString
    .transform((transformedValue, _) => (transformedValue === null ? '' : transformedValue))
    .oneOf(values as string[]) as unknown as yup.BaseSchema;
// yup 0.32 concrete schema types (StringSchema, NumberSchema, etc.) don't satisfy SchemaOf<T>,
// so BaseSchema is used for values. The generic on <T>/<Y> still enforces shape key correctness.
// Downstream type safety is preserved via the Partial<Y> cast in parserFactory's return type.
export const yupObject = <T>(shape: { [field in keyof T]: yup.BaseSchema }) =>
  yup.object().shape(shape).default(undefined);

export const parserFactory = <Y>(shape: { [field in keyof Y]: yup.BaseSchema }): ((
  response: Record<string, any>
) => Partial<Y>) => {
  const parserYup = yup.object().shape(shape);
  return (response: Record<string, any>) =>
    /**
     * Casting the response because validateSync is wrongly typed to potentially
     * returning yup.ValidationError but it is thrown and not returned
     */
    parserYup.validateSync(parserYup.cast(response)) as Partial<Y>;
};
